/* eslint-disable */
import throwModelNotFoundByIdError from '../../Errors/Model/ModelNotFoundById.error';
import { usersFixture } from './User.service.fixture';

/**
 * MockUserService
 * @class MockUserService
 */
class MockUserService {
  /**
   * Creates an instance of `MockUserService`
   * @param {UserServiceCreateDto} dto The params required to create an instance of `MockUserService`
   * @memberof MockUserService
   */
  constructor({ httpService }) {
    this.httpService = httpService;
  }

  /**
   * Find a user by their `id`
   * @param {UserServiceFindByIdDto} dto The required params to find a `user` by their `id`
   * @returns {Promise<UserEntity>} The found `user`
   * @memberof MockUserService
   */
  findById = async ({ id }) => {
    const foundUser = usersFixture.find((user) => user.id === id);
    if (foundUser === undefined) {
      return throwModelNotFoundByIdError(`User`, id);
    }
    return foundUser;
  };

  /**
   * Find a user by their `id`
   * @returns {Promise<UserEntity>} The found `user`
   * @memberof UserService
   */
  getCurrentUser = async () => {
    return {};
  };

  /**
   * Get current user accounts
   * @returns {Promise<Array<OrderAddressEntity>>} The orders
   * @memberof OrderService
   */
  getUserAccounts = async () => {
    return {};
  };

  /**
   * Get current user accounts
   * @returns {Promise<Array<OrderAddressEntity>>} The orders
   * @memberof OrderService
   */
  getUserAccount = async () => {
    return { account: [] };
  };
}

export default MockUserService;
